module.exports = __webpack_public_path__ + "img/Tessellate03.3e4e9a35.png";